import React from "react";
import { RenderIf } from "shared/components";
import { ArrowRight } from "shared/components/Icons";
import "./Index.scss";

const MentorshipStats = ({
  count = 0,
  icon,
  description,
  bgColor,
  isClickable,
  handleClick,
}) => {
  return (
    <div
      className={`mentorship-card ${isClickable ? "cursor" : ""}`}
      style={{ backgroundColor: bgColor }}
      onClick={isClickable ? handleClick : undefined}
    >
      <div className="d-flex gap-3 align-items-center">
        <div className="mentorship-card-icon">{icon}</div>
        <div className="mentorship-card-info">
          <h3>{count}</h3>
          <p>{description}</p>
        </div>
      </div>

      <RenderIf condition={isClickable}>
        <div className="mentorship-card-arrow">
          <ArrowRight />
        </div>
      </RenderIf>
    </div>
  );
};

export default MentorshipStats;
